document.querySelectorAll('[data-slider-id="multicolumn-list"]').forEach(function (swiper) {
  const featuredCollectionSwiper = new Swiper(swiper, {
    slidesPerView: 2,
    spaceBetween: 15,
    loop: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      1024: {
        slidesPerView: 6,
        spaceBetween: 30,
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
      480: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
    },
  });
});
